import { PostCodeCheckResponse, TrackingStatusResponse } from '../Models/Api';

export class StatusApiService {
  getTrackingStatus: (shipmentNumber: string) => Promise<TrackingStatusResponse> = async (
    shipmentNumber
  ) => {
    return fetch(`/api2/tracking?sendung=${shipmentNumber}`, {
      method: 'GET'
    })
      .then((resp) => resp.json())
      .catch(() => {
        throw new Error('Ein Fehler ist aufgetreten');
      });
  };

  postCodeCheck: (postCode: string, shipmentNumber: string) => Promise<PostCodeCheckResponse> =
    async (postCode, shipmentNumber) => {
      return fetch(`/api2/tracking/checkpostcode?postcode=${postCode}&sendung=${shipmentNumber}`, {
        method: 'GET'
      })
        .then((res) => res.json())
        .catch(() => {
          throw new Error('Ein Fehler ist aufgetreten');
        });
    };
}
